import { render } from "./SecurityPolicyView.vue?vue&type=template&id=ce0ae630"
import script from "./SecurityPolicyView.vue?vue&type=script&lang=js"
export * from "./SecurityPolicyView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__